// @flow

import { type Address } from './types';

export function getStreetNumber(address: Address): string {
  return address['street_number'] || '';
}
